import {Directive, HostBinding, Input} from '@angular/core';
import {CopySource, toCopyContact} from './copy-contact';

/** Marks an element as "this is a client" for the right-click copy menu
 *  (see copy-menu.service.ts). Put it on the contact's or account's name,
 *  chip or card and pass the record as it is:
 *
 *    <h3 [gcCopy]="modelOrder.quoteOwner">…</h3>       (first/last name, email, mobile)
 *    <div [gcCopy]="modelOrder.company">…</div>        (company_name, business_phone)
 *    <div [gcCopy]="siteContact">…</div>               (name, email, number)
 *    <span [gcCopy]="{name: x, email: y, phone: z}">   (anything else)
 *
 *  It only writes data attributes - the menu itself is one document-level
 *  listener, so marking a hundred table rows costs no listeners at all.
 *  The record is read on every check rather than once, because screens here
 *  patch a record in place (`contactModel.email = …`) after an edit. */
@Directive({
  standalone: true,
  selector: '[gcCopy]'
})
export class CopyContactDirective {
  @Input() gcCopy: CopySource;

  @HostBinding('attr.data-copy-name') get n() { return toCopyContact(this.gcCopy).name || null; }
  @HostBinding('attr.data-copy-email') get e() { return toCopyContact(this.gcCopy).email || null; }
  @HostBinding('attr.data-copy-phone') get p() { return toCopyContact(this.gcCopy).phone || null; }
}
